import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

const ModalDetailsAdmin = ({ open, setOpen, adminData }) => {
  // console.log("Admin Data:", adminData);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Crear Nuevo Usuario Admin</DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Usuario:</Typography>
              <Typography>{adminData?.userName ?? "Sin dato"}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Rol:</Typography>
              <Typography>
                {adminData?.role === "Admin" ? "Administrador" : "---"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDetailsAdmin;
